import { render } from "./CardSpecOpus.vue?vue&type=template&id=dd87bfce"
import script from "./CardSpecOpus.vue?vue&type=script&lang=js"
export * from "./CardSpecOpus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__